import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../../redux/employeeSlice";
import { Link } from "react-router-dom";
import styles from "./Dashboard.module.css";

export default function AdminDashboard() {
  const dispatch = useDispatch();
  const { employees } = useSelector((state) => state.employees);

  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  const totalEmployees = employees.length;
  const activeEmployees = employees.filter((e) => e.status === "active").length;
  const disabledEmployees = employees.filter((e) => e.status === "disabled").length;

  const stats = [
    { label: "Total Employees", value: totalEmployees, icon: "👥", color: "var(--color-primary)" },
    { label: "Active", value: activeEmployees, icon: "✅", color: "var(--color-success)" },
    { label: "Disabled", value: disabledEmployees, icon: "🚫", color: "var(--color-danger)" },
  ];

  return (
    <div className={styles.dashboard}>
      <div className={styles.header}>
        <h1>Admin Dashboard</h1>
        <p>Welcome to the Vyra Pharma admin portal</p>
      </div>

      <div className={styles.statsGrid}>
        {stats.map((stat) => (
          <div key={stat.label} className={styles.statCard} style={{ "--accent": stat.color }}>
            <div className={styles.statIcon}>{stat.icon}</div>
            <div className={styles.statInfo}>
              <span className={styles.statValue}>{stat.value}</span>
              <span className={styles.statLabel}>{stat.label}</span>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <h2>Quick Actions</h2>
        </div>
        <div className={styles.actionsGrid}>
          <Link to="/admin/employees" className={styles.actionCard}>
            <span className={styles.actionIcon}>👥</span>
            <span className={styles.actionTitle}>View Employees</span>
            <span className={styles.actionDesc}>Manage and monitor all employees</span>
          </Link>
          <Link to="/admin/create-employee" className={styles.actionCard}>
            <span className={styles.actionIcon}>➕</span>
            <span className={styles.actionTitle}>Create Employee</span>
            <span className={styles.actionDesc}>Add a new employee to the system</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
